import * as msgpack from '@mta/msgpack-js-lib';

export default class ValidationCode {
	constructor(
			/** ?int= */ id = null,
			/** ?string= */ value = '',
			/** ?string= */ type = '',
			/** Date= */ expirationTime = null,
			/** ?int= */ idUser = null,
			/** ExternalUser= */ user = null
	) {
		/** @member {?int} */
		this.id = id;
		/** @member {?string} */
		this.value = value;
		/** @member {?string} */
		this.type = type;
		/** @member {Date} */
		this.expirationTime = expirationTime;
		/** @member {?int} */
		this.idUser = idUser;
		/** @member {ExternalUser} */
		this.user = user;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			id: os.writeNullableInt(this.id),
			value: os.writeString(this.value),
			type: os.writeString(this.type),
			expirationTime: os.writeDate(this.expirationTime),
			idUser: os.writeNullableInt(this.idUser),
			user: os.writeObject(this.user)
		};
	}

	/**
	 * @param {!object} is
	 * @param {ValidationCode} value
	 */
	unpack(is, value) {
		if (value.id !== undefined)
			this.id = is.readNullableLong(value.id);
		if (value.value !== undefined)
			this.value = is.readString(value.value);
		if (value.type !== undefined)
			this.type = is.readString(value.type);
		if (value.expirationTime !== undefined)
			this.expirationTime = is.readDate(value.expirationTime);
		if (value.idUser !== undefined)
			this.idUser = is.readNullableLong(value.idUser);
		if (value.user !== undefined)
			this.user = is.readObject(value.user, () => new msgpack.gen.com.arabellesolutions.sdc.b2b.common.user.ExternalUser());
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.common.code.ValidationCode', ValidationCode);
